import axiosPrivate from "@services/axiosPrivate"
import { CANCEL_CALENDAR_BOOKING } from "src/constants"

export const cancelCalendarBooking = (data) =>
    axiosPrivate.post(CANCEL_CALENDAR_BOOKING, data, { withCredentials: true })
